import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    Select,
    useDisclosure,
    // useToast,
} from '@chakra-ui/react';
// import axios from 'axios';

const AddCommessaModal = ({ onAssetAdded }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [name, setName] = useState('');
    const [start, setStart] = useState('');
    const [end, setEnd] = useState('');
    const [total_amount, setTotalAmount] = useState(0.0);
    const [to_be_invoiced, setToBeInvoiced] = useState(0.0);
    const [status, setStatus] = useState('pending');

    // const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();

        let commessa = {name: name,
            start: start,
            end: end,
            total_amount: total_amount,
            to_be_invoiced: to_be_invoiced,
            status: status};

        // onAssetAdded(name, start, end, total_amount, to_be_invoiced, status);
        onAssetAdded(commessa);

        onClose();
        
        // try {
        //     const token = localStorage.getItem('token');
        //     await axios.post(
        //         '/api/assets',
        //         { ticker: ticker, name: name, broker: broker, currency: currency, type: type },
        //         { headers: { Authorization: `Bearer ${token}` } }
        //     );
        //     toast({
        //         title: 'Asset created.',
        //         description: 'The asset has been created successfully.',
        //         status: 'success',
        //         duration: 5000,
        //         isClosable: true,
        //     }); 
        //     onClose();
        //     onAssetAdded();
        // } catch (error) {
        //     toast({
        //         title: 'Error creating asset.',
        //         description: 'There was an error creating the asset.',
        //         status: 'error',
        //         duration: 5000,
        //         isClosable: true,
        //     });
        // }
    };

    return (
        <>
            <Button onClick={onOpen} colorScheme="teal" mb={4}>
                Nuova Commessa
            </Button>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>Nuova Commessa</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <FormControl id="name">
                                <FormLabel>Nome</FormLabel>
                                <Input value={name} onChange={(e) => setName(e.target.value)} />
                            </FormControl>
                            <FormControl id="start" mt={4}>
                                <FormLabel>Inizio</FormLabel>
                                <Input value={start} onChange={(e) => setStart(e.target.value)} />
                            </FormControl>
                            <FormControl id="end" mt={4}>
                                <FormLabel>Fine</FormLabel>
                                <Input value={end} onChange={(e) => setEnd(e.target.value)} />
                            </FormControl>
                            <FormControl id="total_amount" mt={4}>
                                <FormLabel>Fatturato</FormLabel>
                                <Input value={total_amount} onChange={(e) => setTotalAmount(e.target.value)} />
                            </FormControl>
                            <FormControl id="to_be_invoiced" mt={4}>
                                <FormLabel>Da Fatturare</FormLabel>
                                <Input value={to_be_invoiced} onChange={(e) => setToBeInvoiced(e.target.value)} />
                            </FormControl>
                            <FormControl id="status" mt={4}>
                                <FormLabel>Stato di avanzamento</FormLabel>
                                {/* <Input value={currency} onChange={(e) => setCurrency(e.target.value)} /> */}
                                <Select value={status} onChange={(e) => setStatus(e.target.value)} >
                                    <option value="to_start">Da iniziare</option>
                                    <option value="started">In corso</option>
                                    <option value="completed">Completato</option>
                                </Select>
                            </FormControl>
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="teal" mr={3} type="submit">
                                Crea
                            </Button>
                            <Button variant="ghost" onClick={onClose}>
                                Annulla
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AddCommessaModal;